import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";

import constants from "../../assets/constants.js";
import * as BotpressSessionActions from "../../state/redux/botpressSession.js";
import { OmniStringToDate } from "../../utils/helpers.js";
import { helperGetIsoDate, isDateToday } from "../../utils/helpers.js";
import BotpressUseageGraph from "../graphing/botpressUseageGraph.js";
import OmniDateRangePopover from "../ui/omniDateRangePopover.js";
import Widget from "../ui/widget.js";
import WidgetContent from "../ui/widgetContent.js";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle.js";

const BotpressBotUseage = ({
  analytics = [],
  analyticsStartDate,
  analyticsLoading,
  loadAnalyticsRequest,
  botpressGraphType = constants.botpressGraphTypes.usersGraph,
  colorIndex = 0,
  widgetSize = "medium",
  minHeight = "333px",
}) => {
  const [localStartDate, setLocalStartDate] = useState(new Date(helperGetIsoDate(29, true, true))); //7 days
  const [localEndDate, setLocalEndDate] = useState(new Date(helperGetIsoDate(0, false, true)));

  const analyticsRecords = useMemo(() => {
    if (!analytics) return [];
    const localStartString = localStartDate.toISOString();
    let localRecords = analytics.filter(obj => obj.startDateTimeUtc >= localStartString);
    if (isDateToday(localEndDate)) {
      const localIso = localEndDate.toISOString();
      localRecords = localRecords.filter(obj => obj.endDateTimeUtc <= localIso);
    }
    return localRecords;
  }, [analytics, localEndDate, localStartDate]);

  const [titleText, setTitleText] = useState("Loading..");

  useEffect(() => {
    setTitleText(botpressGraphType);
  }, [botpressGraphType]);

  const onRangeChange = (newStartDate, newEndDate) => {
    if (newStartDate < analyticsStartDate) {
      loadAnalyticsRequest({
        analyticsStartDate: new Date(OmniStringToDate(newStartDate)),
      });
    }
    setLocalStartDate(new Date(OmniStringToDate(newStartDate)));
    setLocalEndDate(new Date(OmniStringToDate(newEndDate)));
  };

  return (
    <Widget widgetSize={widgetSize} minHeight={minHeight}>
      <WidgetTitle title={"Analytics"} text={titleText}>
        <OmniDateRangePopover
          analyticsStartDate={localStartDate}
          analyticsEndDate={localEndDate}
          onRangeChange={onRangeChange}
        />
      </WidgetTitle>

      <WidgetContent>
        <BotpressUseageGraph
          records={analyticsRecords}
          botpressGraphType={botpressGraphType}
          colorIndex={colorIndex}
        />
      </WidgetContent>
    </Widget>
  );
};

const mapStateToProps = state => ({
  analytics: state.botpressSession.analytics,
  analyticsStartDate: state.botpressSession.analyticsStartDate,
  analyticsLoading: state.botpressSession.analyticsLoading,
});

const mapDispatchToProps = {
  loadAnalyticsRequest: BotpressSessionActions.loadAnalyticsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BotpressBotUseage);
